import * as React from 'react';

import { useObserver } from 'src/hooks/useObserver';

// Return TRUE to continue observing. FALSE to disconnect. Defaults to TRUE
type ResizeCallback = (details: { width: number; height: number }) => boolean | void;

export function useResizeObserver(callback: ResizeCallback) {
  const observer = React.useMemo(() => {
    return new ResizeObserver((entries, self) => {
      const { width, height } = entries[0].contentRect;
      if (height === 0) {
        return;
      }
      const continueObserving = callback({
        width: Math.ceil(width),
        height: Math.ceil(height),
      });
      if (continueObserving === false) {
        self.disconnect();
      }
    });
  }, [callback]);

  return useObserver(observer);
}
